module.exports = __webpack_public_path__ + "img/inovacao-logo-cn.svg";